/* eslint-disable no-console */
import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';
import { getSession } from 'next-auth/react';

type Severity = 'error' | 'log';

// Function overloads
export function logger(severity: 'log', message: string): Promise<void>;
export function logger(severity: 'error', message: Error): Promise<void>;
export async function logger(
  severity: Severity,
  message: string | Error
): Promise<void> {
  const formattedMessage = `${severity.toUpperCase()}: ${message}`;
  const session = await getSession();

  if (process.env.NODE_ENV === 'production') {
    try {
      const context = {
        env: process.env.NODE_ENV,
        user: session?.user?.email || undefined,
        userId: session?.user?.id || undefined,
        service: window.location.host,
        host: window.location.host,
      };

      if (severity === 'error') {
        datadogRum.addError(message, { ...context });
      } else {
        datadogLogs.logger[severity](formattedMessage, { ...context });
      }
    } catch (error) {
      console.error('Error:', error);
    }
  } else {
    console[severity](formattedMessage);
  }
}
